module.exports = __webpack_public_path__ + "img/download_top.a417b388.png";